module.exports = __webpack_public_path__ + "img/document.9fc62390.svg";